module.exports = __webpack_public_path__ + "static/QRCode-c66152472b9920f2f47e79dc6c1a858b.png";